import { render, staticRenderFns } from "./ExerciseCreatorDesktopDialog.vue?vue&type=template&id=10768977&scoped=true"
import script from "./ExerciseCreatorDesktopDialog.vue?vue&type=script&lang=js"
export * from "./ExerciseCreatorDesktopDialog.vue?vue&type=script&lang=js"
import style0 from "./ExerciseCreatorDesktopDialog.vue?vue&type=style&index=0&id=10768977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10768977",
  null
  
)

export default component.exports